(() => {
  if (!document.body.classList.contains('lf-inner')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  let observer;
  const selector = '.lf-support-cards article, .lf-support-steps li, .lf-card, .lm-members .lm-tier, .lf-detail-aside, .payment-grid article, .lf-education-card, .lf-provider-steps li, .lf-care-directory-grid a';
  function bindMotion() {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lf-in-reveal');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 30px 0px' });
    document.querySelectorAll(selector).forEach(node => {
      if (seen.has(node)) return;
      seen.add(node);
      // Everything is readable immediately; only upcoming content animates.
      if (node.getBoundingClientRect().top > window.innerHeight) observer.observe(node);
    });
  }
  const anchors = [...document.querySelectorAll('.lf-treatment-nav a[href^="#"], .lf-faq-topics>a[href^="#"]')];
  let frame;
  function updateLocation() {
    frame = 0;
    const groups = new Map();
    anchors.forEach(link => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      const parent = link.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push({ link, top: target.getBoundingClientRect().top });
    });
    groups.forEach(items => {
      const active = items.filter(item => item.top <= 150).at(-1) || items[0];
      items.forEach(item => {
        if (item === active) item.link.setAttribute('aria-current', 'location');
        else item.link.removeAttribute('aria-current');
      });
    });
  }
  if (anchors.length) {
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(updateLocation); }, { passive: true });
    updateLocation();
  }
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      document.querySelectorAll('.lf-in-reveal').forEach(node => node.classList.remove('lf-in-reveal'));
    } else bindMotion();
  });
  document.addEventListener('shopify:section:load', bindMotion);
  bindMotion();
})();